import api from './api';

export const modelsService = {
  async getModels(params = {}) {
    const response = await api.get('/models', { params });
    return response.data;
  },

  async getActiveModels() {
    const response = await api.get('/models/active');
    return response.data;
  },

  async getAvailableModels() {
    const response = await api.get('/models/available');
    return response.data;
  },

  async getModelBySlug(slug) {
    const response = await api.get(`/models/${slug}`);
    return response.data;
  },

  async getModelsByProvider(provider) {
    const response = await api.get(`/models/provider/${provider}`);
    return response.data;
  },

  async getModelsByCategory(category) {
    const response = await api.get(`/models/category/${category}`);
    return response.data;
  },

  async getModelsGroupedByProvider() {
    const response = await api.get('/models/grouped/provider');
    return response.data;
  },

  async getModelsGroupedByCategory() {
    const response = await api.get('/models/grouped/category');
    return response.data;
  },
};

export default modelsService;
